import NotificationRepository from "@/js/repositories/NotificationRepository"
const state = {
  notifications: [],
  notificationsRegion: [],
  notification: null,
  lastUpdate: null,
  currentPage: 1,
  notificationForManagement: [],
  detailNotificationManagement: {},
  viewed_flg: false,
}
const getters = {
}
const actions = {
  async getListNotificationForManagement({ commit }) {
    await NotificationRepository.getListNotificationForManagement()
      .then(res => {
        commit('SET_LIST_NOTIFICATIONS_FOR_MANAGEMENT', res.data.data)
      })
  },
  async getDetailNotificationForManagement({ commit }, id) {
    await NotificationRepository.getDetailNotificationForManagement(id)
      .then(res => {
        commit('SET_DETAIL_NOTIFICATIONS_FOR_MANAGEMENT', res.data.data)
      })
      .catch(err => {
        commit('SET_DETAIL_NOTIFICATIONS_FOR_MANAGEMENT', undefined)
      })
  },
  async deleteDetailNotificationMangement({ commit }, id) {
    await NotificationRepository.deleteDetailNotificationMangement(id)
      .then(response => {
      })
  },
  async registerNotificationMangement({ commit }, data) {
    await NotificationRepository.registerNotificationMangement(data)
      .then(response => {
      })
  },
  async updateNotificationMangement({ commit }, payload) {
    await NotificationRepository.updateNotificationMangement(payload)
      .then(response => {
      })
  },
  async getNotifications({ commit }, region) {
    if (region === 'region') {
      await NotificationRepository.getNotifications(region)
      .then(res => {
        const data = res.data.data
        commit('SET_NOTIFICATIONS_REGION', 
          data.notifications.sort((a, b) =>{return new Date(b.sending_time) - new Date(a.sending_time)})
        )
        commit('SET_VIEWED_FLG', data.viewed_flg)
      })
    }
    else {
      await NotificationRepository.getNotifications(region)
      .then(response =>
          response.json().then(data => ({
              data: data
          })
        ).then(res => {
          const notifications = res.data
          commit('SET_NOTIFICATIONS', notifications.information)
          commit('SET_LAST_UPDATE', notifications.lastUpdate)
        }))
    }
  },
  async updateViewedNotification({ commit }, id) {
    await NotificationRepository.putNotifications(id)
  },
  async postUploadFiles({ commit }, base64Files) {
    return await NotificationRepository.postUploadFiles(base64Files)
  },
  async getFileFromS3({ commit }, filePath) {
    return await NotificationRepository.getFileFromS3(filePath)
  },
  setViewedFlg({ commit }, data) {
    commit('SET_VIEWED_FLG', data)
  },
  setNotificationDetail ({ commit }, data) {
    commit('SET_NOTIFICATION', data)
  },
  setCurrentPage ({ commit }, data) {
    commit('SET_CURRENT_PAGE', data)
  },
};
const mutations = {
  SET_LIST_NOTIFICATIONS_FOR_MANAGEMENT(state, data) {
    state.notificationForManagement = data
  },
  SET_DETAIL_NOTIFICATIONS_FOR_MANAGEMENT(state, data) {
    state.detailNotificationManagement = data
  },
  SET_NOTIFICATIONS_REGION(state, data) {
    state.notificationsRegion = data
  },
  SET_NOTIFICATIONS(state, data) {
    state.notifications = data
  },
  SET_NOTIFICATION(state, data) {
    state.notification = data
  },
  SET_CURRENT_PAGE(state, data) {
    state.currentPage = data
  },
  SET_LAST_UPDATE(state, data) {
    state.lastUpdate = data
  },
  SET_VIEWED_FLG(state, data) {
    state.viewed_flg = data
  },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
